// 
var DouyinRevisitRewardRedirector = xClass("DouyinRevisitRewardRedirector", BaseRedirector)
DouyinRevisitRewardRedirector.prototype.getName = function () {
    var self = this
    return "douyinRevisitReward"
}
DouyinRevisitRewardRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
DouyinRevisitRewardRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    
    console.log("[tt] DouyinRevisitRewardRedirector redirect ", mini.getPlatform())
    let hasGet = UserManager.getInstance().getTTRevisistReward()
    console.log("[tt] DouyinRevisitRewardRedirector hasGet ", hasGet)
    var scene = cc.Director.getInstance().getRunningScene()
    if (scene && scene.name === "HomeScene" && global.mini && mini.getPlatform() === MiniPlatform.tt && hasGet == false) {
        if (param.tt_launch_from && param.tt_location){
            console.log("[tt] param.tt_launch_from=", param.tt_launch_from)
            console.log("[tt] param.tt_location=", param.tt_location)
        }
        let tt_sidebar = getParameterByName('tt_sidebar')
        console.log("[tt] DouyinRevisitRewardRedirector tt_sidebar=", tt_sidebar)
        if ((__DEBUG && tt_sidebar == "1") || (param.tt_launch_from == "homepage" && param.tt_location == "sidebar_card")){
            self.dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
            DCAssist.dc4DouyinSidebar("finish_task_return", self.dcSession)
            let http = DouyinSideRewardsFetchHttp.new()
            http.addEventListener(Events.kComplete, (evt)=>{
                UserManager.getInstance().setTTRevisistReward(true)
                let rewards = evt.data.rewards
                
                ActivityGetRewardsPanel.show({
                    type:1,
                    add_model: "douyin_sidebar_task",
                    rewardList: rewards,
                    tobagAni: true,
                    title: "normal",
                    closeCb:()=>{
                        DCAssist.dc4DouyinSidebar("finish_task_click", self.dcSession)
                    }
                })
            })
            http.addEventListener(Events.kError, (evt) => {
                if (evt.data == 762481){
                    console.log("[tt] DouyinRevisitRewardRedirector setTTRevisistReward true")
                    UserManager.getInstance().setTTRevisistReward(true)
                    return
                }
                Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
            })
            http.addEventListener(Events.kCancel, (evt) => {
                Toast.make(quickGetErrorText( evt.data, getText("error.tip.load_res_error")))
            })
            http.load()
        }

        return true
    }
    return false
}
module.exports = DouyinRevisitRewardRedirector
